import request from "@/helper/request"; // 或 axios 封装实例

export function getUserContactHistory(params) {
  return request({
    url: "/api/getUserContactHistory/",
    method: "post",
    data: params
  });
}

export function deleteUserContact(data) {
  return request({
    url: "/api/deleteUserContact/",
    method: "post",
    data
  });
}

export function updateUserContactStatus(data) {
  return request({
    url: "/api/updateUserContactStatus/",
    method: "post",
    data
  });
}
